module.exports = __webpack_public_path__ + "img/1.51e830c5.jpg";